/**Multiselector de varias guias */

import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { addDate, truncateDate, all, allEqual, intersectKeys, toObservable, nullsafe, shallowEquals } from "keautils";
import { MultiselectorEntregasList } from "./list";
import { FiltroEntregaComponent } from "./filtro";

export interface Props {
    /**Folios de las guias seleccionadass¿ */
    value: number[];
    filtro: Partial<models.FiltroEntregaZE>;
    onChange: (value: number[]) => void;
    onFiltroChange: (filtro: models.FiltroEntregaZE) => void;
}

class MultiselectorEntregasNoRx extends React.PureComponent<Props> {

    /**Función que carga las guias */
    loadFunction = kea.loadItemsFuncFromResource(
        filtro => observeResource(resources.EntregaZERealizada.Query, filtro),
        id => observeResource(resources.EntregaZERealizada.get, id),
        x => x.IdRegistro,
        x => true);

    usuario = (props: Props) => resources.User.SessionRx;
    permisosFiltroSucursal = createSelectorRx(this.usuario, usuario => ({
        verOtrasSucursales: usuario.Permisos.EntregaOcurre.MostrarGuiasSucursalDiferenteUsuario,
        idSucursal: usuario.IdSucursal
    }));

    filtro = (props: Props) => props.filtro;

    filtroEff = createSelectorRx(this.filtro, this.permisosFiltroSucursal, (filtro, permisos) => ({
        ...filtro,
        Liberada: false,
        NecesitaLiberacion: true,
    } as models.FiltroEntregaZE));

    value = (props: Props) => props.value;
    entregas = createSelectorRx(this.filtro, this.value, (filtro, value) => this.loadFunction(filtro as models.FiltroEntregaZE, value));
    selected = createSelectorRx(this.entregas, this.value, (guias, value) => intersectKeys(guias, value, x => x.IdRegistro));

    render() {
        const entregas = this.entregas(this.props);
        const selected = this.value(this.props);
        const filtro = this.filtroEff(this.props);
        return (
            <div>
                <FiltroEntregaComponent value={filtro} onChange={this.props.onFiltroChange} />
                <kea.Title titulo="Entregas realizadas" size="h4" />
                <MultiselectorEntregasList items={entregas} value={selected} onChange={this.props.onChange} />
            </div>
        )
    }
}

const now = truncateDate(new Date(), "days");
export const MultiselectorEntregas = kea.defaultProps(componentToRx(kea.mapProps<Props>(MultiselectorEntregasNoRx, x => ({
    ...x,
    filtro: { ...x.filtro, Liberada: false, NecesitaLiberacion: true },
}))), {

    });


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/liberacionentregasZE/components/multientregas/index.tsx